export default {
  title: 'Arkusz USFans: kompletny poradnik, linki i zasoby 2026',
  metaDescription: 'Kompletny poradnik o arkuszu USFans: zasoby, badanie produktów, sprzedawcy, QC, wysyłka, procesy magazynowe i wskazówki bezpieczeństwa na rok 2026.',
  h1: 'Arkusz USFans: kompletny poradnik, linki i zasoby 2026',
  breadcrumbHome: 'Strona główna',
  breadcrumbCurrent: 'Poradnik o arkuszu USFans',

  intro1: 'Arkusz USFans to jedno z najczęściej wyszukiwanych źródeł dla osób, które chcą w jasny i uporządkowany sposób przeglądać produkty, oceniać sprzedawców i planować zamówienia. Zamiast skakać między rozproszonymi stronami, dobrze zbudowany arkusz łączy potrzebne informacje w jednym widoku.',
  intro2: 'Ten poradnik wyjaśnia, czym jest arkusz USFans, jak go używać, jakie kategorie obejmuje oraz co warto wiedzieć o kontroli jakości, wysyłce i bezpieczeństwie konta. Jest napisany zarówno dla początkujących, jak i doświadczonych kupujących, i pozostaje niezależny od pojedynczego sprzedawcy czy platformy.',

  takeawaysTitle: 'Najważniejsze wnioski',
  takeaway1: 'Arkusz USFans porządkuje informacje o produktach, sprzedawcach i wysyłce w jednym łatwym do przeglądania zasobie.',
  takeaway2: 'Popularne kategorie to buty, bluzy, koszulki, kurtki, torby, akcesoria i inne.',
  takeaway3: 'Zdjęcia QC (kontrola jakości) pomagają zweryfikować przedmiot przed wysyłką.',
  takeaway4: 'Metody i koszty wysyłki są różne, dlatego zawsze sprawdzaj opcje przed zamówieniem.',
  takeaway5: 'Zachowaj bezpieczeństwo, chroniąc hasło, kody weryfikacyjne i dane płatnicze.',

  tocTitle: 'Czego się nauczysz',

  whatTitle: 'Czym jest arkusz USFans?',
  what1: 'Mówiąc prościej, arkusz USFans to uporządkowana lista produktów i zasobów, która ułatwia przeglądanie. Wielu kupujących używa go jako punktu wyjścia, ponieważ grupuje przedmioty w czytelne kategorie, zamiast zmuszać do przeszukiwania dziesiątek niepowiązanych stron.',
  what2: 'Wartością dobrego arkusza jest organizacja. Dobrze prowadzona lista pomaga porównywać podobne przedmioty, dostrzegać, co jest popularne w danej kategorii, i szybko przejść od „ciekawe” do „gotowy sprawdzić szczegóły”.',

  howTitle: 'Jak korzystać z arkusza',
  how1: 'Zacznij od wybrania kategorii, która pasuje do tego, czego szukasz, na przykład Buty lub Akcesoria. Następnie spójrz na nazwę przedmiotu, informacje o sprzedawcy i dostępne zdjęcia kontroli jakości. To pomoże zawęzić wybór, zanim poświęcisz czas na poszczególne strony produktów.',
  how2: 'Gdy znajdziesz przedmiot, który Ci się podoba, przejrzyj szczegóły wysyłki i QC. Odrobina dodatkowego czasu pomoże uniknąć niespodzianek. Rób własne notatki, aby porównywać opcje obok siebie.',

  categoriesTitle: 'Popularne kategorie',
  categories1: 'Arkusz zwykle obejmuje szeroki zakres kategorii odzieżowych i lifestylowych. Do najczęstszych należą: buty, bluzy i swetry, koszulki, kurtki, spodnie i szorty, nakrycia głowy, zestawy, bielizna, koszulki sportowe, akcesoria, torby, paski, perfumy i inne drobne przedmioty.',

  qcTitle: 'QC: sprawdź przed zakupem',
  qc1: 'Zdjęcia kontroli jakości to jedna z najbardziej przydatnych części procesu. Pokazują rzeczywisty przedmiot przed wysyłką, dzięki czemu możesz zweryfikować kolor, szwy, logo i ogólny stan. Zawsze dokładnie przeglądaj zdjęcia QC i pytaj, jeśli coś wygląda inaczej niż oczekiwałeś.',

  shippingTitle: 'Wysyłka i dostawa',
  shipping1: 'Metody, koszty i czas wysyłki mogą się różnić w zależności od sprzedawcy i lokalizacji. Wysyłka międzynarodowa często wiąże się z dodatkowymi kwestiami, takimi jak śledzenie, cło i okna dostawy. Zawsze potwierdź opcję wysyłki i szacowany czas przed złożeniem zamówienia.',

  tableTitle: 'Szybki przegląd',
  tableHeader1: 'Temat',
  tableHeader2: 'Czego się dowiesz',
  tableHeader3: 'Dla kogo',
  tableRow1Col1: 'Arkusz',
  tableRow1Col2: 'Zasoby produktów i sprzedawców',
  tableRow1Col3: 'Badania',
  tableRow2Col1: 'QC',
  tableRow2Col2: 'Kontrola jakości',
  tableRow2Col3: 'Kupujący',
  tableRow3Col1: 'Wysyłka',
  tableRow3Col2: 'Opcje dostawy',
  tableRow3Col3: 'Planowanie',
  tableRow4Col1: 'Magazyn',
  tableRow4Col2: 'Przechowywanie i kontrola',
  tableRow4Col3: 'Zamówienia',
  tableRow5Col1: 'Bezpieczeństwo',
  tableRow5Col2: 'Ochrona konta',
  tableRow5Col3: 'Wszyscy',

  faqTitle: 'Najczęstsze pytania',
  faq1q: 'Czy przeglądanie arkusza USFans jest darmowe?',
  faq1a: 'Sam arkusz służy do porządkowania informacji o produktach i sprzedawcach. Ceny poszczególnych produktów i koszty wysyłki mogą się różnić w zależności od sprzedawcy, dlatego zawsze sprawdzaj szczegóły każdego przedmiotu przed zamówieniem.',
  faq2q: 'Jak korzystać ze zdjęć QC?',
  faq2a: 'Zdjęcia QC pozwalają zobaczyć rzeczywisty przedmiot przed wysyłką. Sprawdź kolor, szwy, logo i ogólny stan, a jeśli coś jest niejasne lub różni się od oferty, zapytaj sprzedawcę.',
  faq3q: 'Czy wysyłka kosztuje dodatkowo?',
  faq3a: 'Metody i koszty wysyłki różnią się w zależności od sprzedawcy i miejsca docelowego. Zawsze potwierdź opcję wysyłki, śledzenie i szacowane okno dostawy przed złożeniem zamówienia.',
  faq4q: 'Czy USFans jest bezpieczne?',
  faq4a: 'Jak w przypadku każdej platformy internetowej, bezpieczeństwo zależy od tego, jak z niej korzystasz. Chroń hasło i kody weryfikacyjne, nie udostępniaj danych płatniczych przez niezweryfikowane kanały i korzystaj wyłącznie z bezpiecznych, zaufanych witryn.',

  backHome: 'Wróć do strony głównej',
  authorLabel: 'Autor',
  authorName: 'Zespół redakcyjny USFansLink',
  publishedLabel: 'Opublikowano',
  publishedDate: 'Sierpień 2026',
  updatedLabel: 'Ostatnia aktualizacja',
  updatedDate: 'Sierpień 2026',
  ctaTitle: 'Gotowy na poznanie arkusza USFans?',
  ctaText: 'Przeglądaj uporządkowane kategorie, porównuj produkty i planuj kolejne zamówienie z pewnością.',
};